import * as React from 'react'
import { FC } from 'react'
import { Labeled, useRecordContext } from 'react-admin'
import { useController } from 'react-hook-form'

interface CustomInputProps {
  children: JSX.Element
  label?: string
  onChange?: (...props: any) => void
  source: string
}

export const CustomInput: FC<CustomInputProps> = ({ children, label, onChange, source }) => {
  const { field } = useController({ name: source })
  const record = useRecordContext()

  if (!record) return

  return (
    <>
      <Labeled label={label || source}>
        {React.cloneElement(React.Children.only(children), {
          ...field,
          onChange: onChange,
        })}
      </Labeled>
      {/* render={({ input, meta }) => {
         return (
           <>
             <Labeled label={label || source}>
               {React.cloneElement(React.Children.only(children), {
                 onChange: onChange ? onChange : input.onChange,
               })}
             </Labeled>
             {meta && meta.touched && meta.error && (
               <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-marginDense">{meta.error}</p>
             )}
           </>
         );
       }} */}
    </>
  )
}
